















import { Component, Vue, Prop } from "vue-property-decorator";
// rapidoc library is included directly in public/index.html
// it's done like this because including it as an import was a headache

@Component
export default class OpenAPIDocs extends Vue {
  @Prop({ required: true }) url!: string;
  @Prop({ default: () => ({}) }) options: unknown;

  defaultProps = {};

  mounted() {
    document.getElementById("thedoc")?.setAttribute("spec-url", this.url);
    //require("rapidoc/dist/rapidoc-min.js");
  }
}
